import { Button, Checkbox, Modal } from "antd";
export const HideKeywordModal = ({
  tempModal,
  permModal,
  brandModal,
  modalCheckboxValue,
  setPermModal,
  setTempModal,
  setBrandModal,
  setModalCheckboxValue,
  removeTemporarily,
  removePermanently,
  removePermanentlyFromBrand,
  setxPosition,
  setyPosition,
}) => {
  const handleOk = (e, type) => {
    if (tempModal) {
      removeTemporarily(e);
      setTempModal(false);
    } else if (permModal) {
      removePermanently(e);
      setPermModal(false);
    } else if (brandModal) {
      removePermanentlyFromBrand(e);
      setBrandModal(false);
    }
  };

  const handleCancel = () => {
    setTempModal(false);
    setPermModal(false);
    setBrandModal(false);
    setModalCheckboxValue(false);
    setxPosition(0);
    setyPosition(0);
  };

  const GetTitle = () => {
    let titleText = "";
    if (tempModal) {
      titleText = "Do you want to hide word temporarily?";
    } else if (permModal) {
      titleText = "Do you want to hide word permanently?";
    } else if (brandModal) {
      titleText =
        "Do you want to hide word permanently from this Brand/Logical Group(s)?";
    }

    return (
      <span className="text_heading-Slab text-transform__none">
        {titleText}
      </span>
    );
  };

  return (
    <Modal
      title={<GetTitle />}
      visible={tempModal || permModal || brandModal}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Checkbox
          key="checkbox"
          style={{ float: "left" }}
          checked={modalCheckboxValue}
          onChange={(e) => setModalCheckboxValue(e.target.checked)}
        >
          Do not show me again
        </Checkbox>,
        <Button
          class="ant-btn ant-btn-button mr-2 btn_Clear"
          key="back"
          onClick={handleCancel}
        >
          No
        </Button>,
        <Button
          class="ant-btn ant-btn-primary ant-btn-primary_blue"
          key="submit"
          type="primary"
          onClick={handleOk}
        >
          Yes
        </Button>,
      ]}
    >
      <p className="text_regular text-transform__none font-weight400 line-height-normal">
        {tempModal
          ? "The word will be hidden from this widget for the current session only. You can unhide this word from the hidden words list."
          : permModal
          ? "The word will be hidden from this widget permanently. You can unhide this word from the hidden words list."
          : brandModal
          ? "The word will be hidden from this brand permanently on all dashboards and widget maker. You can unhide this word from the hidden words list."
          : ""}
      </p>
    </Modal>
  );
};
